import { render, staticRenderFns } from "./PriceView.vue?vue&type=template&id=700035fc&"
import script from "./PriceView.vue?vue&type=script&lang=js&"
export * from "./PriceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports